const wait = (pTimer) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve();
        }, pTimer);
    });
}

export default wait;